let megamenuMask = document.querySelectorAll('.megamenu-mask');

document.querySelectorAll('.header_navigation-main_link.has-megamenu').forEach(function (element) {
  element.addEventListener('click', function (e) {
    let headerNavigationMainLinkWrapperIsActive = document.querySelectorAll('.header_navigation-main_link-wrapper.is-active');
    let megamenuMaskLeft = document.querySelectorAll('.megamenu-mask.megamenu-mask-left');
    let megamenuMaskRight = document.querySelectorAll('.megamenu-mask.megamenu-mask-right');

    let headerNavigationMainLinkHasMegamenu = e.target;

    if (headerNavigationMainLinkHasMegamenu.parentNode.classList.contains('is-active')) {
      headerNavigationMainLinkHasMegamenu.parentNode.classList.remove('is-active');

      for (let i1 = 0; i1 < megamenuMaskLeft.length; i1++) {
        megamenuMaskLeft[i1].classList.remove('is-active');
      }

      for (let i2 = 0; i2 < megamenuMaskRight.length; i2++) {
        megamenuMaskRight[i2].classList.remove('is-active');
      }

      document.body.classList.remove('noScroll');
    } else {
      for (let i3 = 0; i3 < headerNavigationMainLinkWrapperIsActive.length; i3++) {
        headerNavigationMainLinkWrapperIsActive[i3].classList.remove('is-active');
      }

      headerNavigationMainLinkHasMegamenu.parentNode.classList.add('is-active');

      for (let i4 = 0; i4 < megamenuMaskLeft.length; i4++) {
        megamenuMaskLeft[i4].classList.add('is-active');
      }

      for (let i5 = 0; i5 < megamenuMaskRight.length; i5++) {
        megamenuMaskRight[i5].classList.add('is-active');
      }

      document.body.classList.add('noScroll');
    }
  });
});

// Mega menu close
function megaMenuClose() {
  let headerNavigationMainLinkWrapperIsActive = document.querySelectorAll('.header_navigation-main_link-wrapper.is-active');
  let megamenuMaskLeft = document.querySelectorAll('.megamenu-mask.megamenu-mask-left');
  let megamenuMaskRight = document.querySelectorAll('.megamenu-mask.megamenu-mask-right');

  for (let i6 = 0; i6 < headerNavigationMainLinkWrapperIsActive.length; i6++) {
    headerNavigationMainLinkWrapperIsActive[i6].classList.remove('is-active');
  }

  for (let i7 = 0; i7 < megamenuMaskLeft.length; i7++) {
    megamenuMaskLeft[i7].classList.remove('is-active');
  }

  for (let i8 = 0; i8 < megamenuMaskRight.length; i8++) {
    megamenuMaskRight[i8].classList.remove('is-active');
  }

  document.body.classList.remove('noScroll');
}

if (megamenuMask.length) {
  megamenuMask.forEach(function (element) {
    element.addEventListener('click', megaMenuClose);
  })
}
